import { render, staticRenderFns } from "./TermsPopup.vue?vue&type=template&id=9c64e026&scoped=true&"
import script from "./TermsPopup.vue?vue&type=script&lang=js&"
export * from "./TermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./TermsPopup.vue?vue&type=style&index=0&id=9c64e026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c64e026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c64e026')) {
      api.createRecord('9c64e026', component.options)
    } else {
      api.reload('9c64e026', component.options)
    }
    module.hot.accept("./TermsPopup.vue?vue&type=template&id=9c64e026&scoped=true&", function () {
      api.rerender('9c64e026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/TermsPopup.vue"
export default component.exports